import React from 'react';

import { Typography, Card, CardContent, CardHeader } from '@occc-app/design-system';

type ICardLayoutProps = {
  children?: React.ReactNode;
  title: string;
};

export const CardLayout = ({ title, children }: ICardLayoutProps) => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant='h6' component='h4' gutterBottom>
            {title}
          </Typography>
        }
      />
      <CardContent>{children}</CardContent>
    </Card>
  );
};
